/**
 * 添加签约渠道
 * 2018-3-9
 * geyuankai
 */
"use strict";
angular.module("addContractChannelModule", ["zoneServiceModule"]).
controller("addContractChannelCtrl", ["$scope", "$q", "$element", "zoneService", "Upload", "editPictureService", "$validation", "httpService", "modalDialog", "$modalInstance", "type", "item", function($scope, $q, $element, zoneService, Upload, editPictureService, $validation, httpService, modalDialog, $modalInstance, type, item) {
	initStatus();
	initData();

	function initStatus() {
		$scope.status = {
			channelsOptions: [],
			selectChannel: {},
			type: type,
			hasHeadPic: false, //判断是否上传了头像
			hasChannel: false, //判断是否选择了渠道
		};
		$scope.data = {};
		if(item != "") {
			$scope.headPic = item.accountLogo;
			$scope.logo = item.accountLogo;
			$scope.status.selectChannel = {
				name: item.channelName,
				value: item.channelId
			};
			$scope.status.info = angular.copy(item);
		} else {
			$scope.headPic = "";
			$scope.logo = "";
			$scope.status.info = {};
		}
	}

	function initData() {
		initChannelsList();
	}
	/**
	 * [initChannelsList description] 初始化签约渠道下拉菜单
	 * @return {[type]} [description]
	 */
	function initChannelsList() {
		var deferred = $q.defer();
		httpService.http("/mcnww/web/ucenter/findUnSelectChannels.do", "", "post").then(function(data) {
			var item = data.data;
			for(var i = 0; i < item.length; i++) {
				var creatJSON = {};
				creatJSON.name = item[i].channelName;
				creatJSON.value = item[i].id;
				$scope.status.channelsOptions.push(creatJSON);
			}
			deferred.resolve(data);
		});
		return deferred.promise;
	}
	/**
	 * [confirm description] 保存渠道信息
	 * @return {[type]} [description]
	 */
	$scope.confirm = function() {
		/*
		 * 判断有没有上传头像
		 */
		if($scope.headPic == "") {
			$scope.status.hasHeadPic = true;
			return;
		}
		/**
		 * 判断有没有选择渠道
		 */
		if(!$scope.status.selectChannel.hasOwnProperty('value')) {
			$scope.status.hasChannel = true;
			return;
		}
		$validation.validate($scope.channelInfo).success(function() {
			var txt = "";
			if($scope.status.type == 0) {
				txt = '确认新建该签约渠道吗？'
			} else {
				txt = '确认修改该签约渠道吗？'
			}
			modalDialog.confirmModal('保存', txt, function() {
				var params = {
					channelId: $scope.status.selectChannel.value, //用户签约渠道ID
					accountLogo: $scope.headPic, //账号头像
					accountName: $scope.status.info.accountName, //账号名称
					accountDesc: $scope.status.info.accountDesc //账号介绍
				};
				httpService.http("/mcnww/web/ucenter/pgcSaveUserChannel.do", params, "post", true, true).then(function(result) {
					if(result.success) {
						let s = ""
						if($scope.status.type == 0) {
							s = '签约渠道新建成功！'
						} else {
							s = '签约渠道修改成功！'
						}
						modalDialog.success(s, "success", false, function() {}, function() {}, '', 'changePhoneSuccess');
						$modalInstance.close();
					}
				});
			});

		}).error(function() {
			angular.invalidPosition($scope.channelInfo, $element);
		});
	};
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};
	/**
	 * [selectChannel description] 渠道下拉框的点击回调事件
	 * @return {[type]} [description]
	 */
	$scope.selectChannel = function() {
		$scope.status.hasChannel = false;
	}
	/**
	 * [changeHeadPortrait description]  更换头像
	 * @param  {[type]} files    [description]
	 * @param  {[type]} file     [description]
	 * @param  {[type]} newFiles [description]
	 * @return {[type]}          [description]
	 */
	$scope.changeHeadPortrait = function(files, file, newFiles) {
		if(!file) return;
		if(file.size > Number($scope.status.picSizeLimit) * 1024) {
			modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
			return;
		}
		if(newFiles) {
			$scope.status.changeHeader = true;
		}
		uploadPic(file).then(function(resp) {
			editPictureService.newCropperApp(angular.globalConfig.pictureServer + resp.url, "100,100").then(function(data) {
				var time = new Date().getTime();
				$scope.headPic = data.imgSrc + '?' + time;
				$scope.logo = data.imgSrc;
				$scope.status.hasHeadPic = false;
			})
		}).catch(function(error){
			modalDialog.alertType("", error.message, "error", false);
		});
	};
	/**
	 * [uploadPic description] 上传图片的公共方法
	 * @return {[type]} [description]
	 */
	function uploadPic(file) {
		var defer = $q.defer();
		if(file.size > Number($scope.status.picSizeLimit) * 1024) {
			defer.reject({success:'false',message:'图片最大不能超过'+ $scope.status.picSizeLimit + "KB!"});
		}
		var fd = new FormData();
		var name = file.name;
		fd.append("file", file);
		fd.append("name", name);
		$.ajax({
			url: '/mcnww/upload/image.do',
			type: 'POST',
			headers:{requestToken:sessionStorage.getItem('requestToken')},
			async: false,
			data: fd,
			processData: false,
			contentType: false,
			success: function(data) {
				if(data.success){
					defer.resolve(data);
				}else{
					defer.reject(data);
				}
			}
		});
		return defer.promise;
	}
	/**
	 * [getPicSizeLimit description] 获取图片尺寸上限
	 * @return {[type]} [description]
	 */
	function getPicSizeLimit() {
		httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function(data) {
			$scope.status.picSizeLimit = data.message;
		});
	}

	$scope.singleValidate = function(name) {
		$validation.validate();
	};
}]);